import script from "./NewsTabsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsTabsSection.vue?vue&type=script&setup=true&lang=js"

import "./NewsTabsSection.vue?vue&type=style&index=0&id=7ab30d5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab30d5f"]])

export default __exports__